// src/views/source-connections/components/wizard/StepConfigure.jsx

import React from "react";
import Input from "../../../../components/form-components/Input";
import ApiKeyForm from "./forms/ApiKeyForm";
import ServiceAccountForm from "./forms/ServiceAccountForm";
import OAuthForm from "./forms/OAuthForm";
import CsvUploadForm from "./forms/CsvUploadForm";

const FORM_MAP = {
  api_key: ApiKeyForm,
  service_account_key: ServiceAccountForm,
  oauth_token: OAuthForm,
  csv_upload: CsvUploadForm,
};

const StepConfigure = ({ sourceType, formData, onChange }) => {
  const FormComponent = FORM_MAP[sourceType.authMethod];

  return (
    <div className="overflow-y-auto" style={{ maxHeight: "60vh" }}>
      <div className="flex items-center gap-3 p-4 bg-surface-2 border-b border-border">
        <div className={`w-8 h-8 rounded-md ${sourceType.icon.bgColor} flex items-center justify-center text-sm font-bold ${sourceType.icon.textColor}`}>
          {sourceType.icon.letter}
        </div>
        <div>
          <div className="text-sm font-semibold text-text">{sourceType.name}</div>
          <div className="text-xs text-text-2">{sourceType.description}</div>
        </div>
      </div>

      <div className="p-6">
        <div className="mb-5">
          <Input
            title="Connection Name"
            name="connection_name"
            type="text"
            value={formData.connection_name || ""}
            onChange={(e) => onChange({ ...formData, connection_name: e.target.value })}
            placeholder="e.g. Production Billing Export"
          />
          <p className="text-xs text-text-2 -mt-6 mb-4">A descriptive name to identify this connection.</p>
        </div>

        {FormComponent && (
          <FormComponent
            sourceType={sourceType}
            formData={formData}
            onChange={onChange}
          />
        )}
      </div>
    </div>
  );
};

export default StepConfigure;
